import Container from "./Container";
import PortalDocument from "./PortalDocument";
import MimeTypeFilter from "./mimetype/MimeTypeFilter";
import MimeTypes from "./mimetype/MimeTypes";
import FileTypeGroupFilter from "./mimetype/FileTypeGroupFilter";
import FileTypeGroup from "./mimetype/FileTypeGroup";
import DefaultContainer from "./DefaultContainer";
import PdfContainer from "./PdfContainer";
import ImageContainer from "./ImageContainer";
import TextContainer from "./TextContainer";
import ZipContainer from "./ZipContainer";
import HtmlContainer from "./HtmlContainer";
import RtfContainer from "./RtfContainer";
import TiffContainer from "./TiffContainer";
import HeicContainer from "./HeicContainer";
import MimeType from "./mimetype/MimeType";
import ViewerType from "./DataType";
import FunctionHelper from "../../shared/helper/FunctionHelper";

export default class ContainerFactory {
	private constructor() {
		// not constructable
	}

	public static getViewerType(mimeType: MimeType, fileTypeGroups?: string): ViewerType {
		if (MimeTypeFilter.checkSelection([mimeType], [MimeTypes.PDF])) {
			return ViewerType.PDF;
		} else if (MimeTypeFilter.checkSelection([mimeType], [
			MimeTypes.GIF, MimeTypes.PNG, MimeTypes.JPEG, MimeTypes.BMP, MimeTypes.SVG, MimeTypes.XPNG, MimeTypes.XBMP,
			MimeTypes.ICO, MimeTypes.WEBP
		])) {
			return ViewerType.IMAGE;
		} else if (MimeTypeFilter.checkSelection([mimeType], [
			MimeTypes.PLAIN, MimeTypes.XML, MimeTypes.APPXML, MimeTypes.APPXSLTXML, MimeTypes.JSON, MimeTypes.APPJSON,
			MimeTypes.XFDF, MimeTypes.XDP
		])) {
			return ViewerType.TEXT;
		} else if (MimeTypeFilter.checkSelection([mimeType], [
			MimeTypes.ZIP, MimeTypes.XZIP, MimeTypes.X7ZIP, MimeTypes.TAR, MimeTypes.GZIP, MimeTypes.RAR
		])) {
			return ViewerType.ZIP;
		} else if (MimeTypeFilter.checkSelection([mimeType], [
			MimeTypes.HTML, MimeTypes.DOC, MimeTypes.DOCX
		]) || FileTypeGroupFilter.checkSelection(
			[FunctionHelper.applyValue(fileTypeGroups, "")], [FileTypeGroup.MAIL])
		) {
			return ViewerType.HTML;
		} else if (MimeTypeFilter.checkSelection([mimeType], [MimeTypes.RTF])) {
			return ViewerType.RTF;
		} else if (MimeTypeFilter.checkSelection([mimeType], [MimeTypes.TIFF])) {
			return ViewerType.TIFF;
		} else if (MimeTypeFilter.checkSelection([mimeType], [
			MimeTypes.HEIF, MimeTypes.HEIC, MimeTypes.HEIF_SEQUENCE, MimeTypes.HEIC_SEQUENCE
		])) {
			return ViewerType.HEIC;
		}

		return ViewerType.DEFAULT;
	}

	public static createInstance(viewerType: ViewerType, portalDocument?: PortalDocument): Container {
		switch (viewerType) {
			case ViewerType.PDF:
				return new PdfContainer(portalDocument);
			case ViewerType.IMAGE:
				return new ImageContainer(portalDocument);
			case ViewerType.TEXT:
				return new TextContainer(portalDocument);
			case ViewerType.ZIP:
				return new ZipContainer(portalDocument);
			case ViewerType.HTML:
				return new HtmlContainer(portalDocument);
			case ViewerType.RTF:
				return new RtfContainer(portalDocument);
			case ViewerType.TIFF:
				return new TiffContainer(portalDocument);
			case ViewerType.HEIC:
				return new HeicContainer(portalDocument);
		}

		return new DefaultContainer(portalDocument);
	}
}